(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7429],{

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 3805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KM": function() { return /* binding */ PrimaryButton; },
/* harmony export */   "hG": function() { return /* binding */ BrandButton; },
/* harmony export */   "kq": function() { return /* binding */ SecondaryButton; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88154);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "onClick"],
    _excluded2 = ["children", "onClick"],
    _excluded3 = ["children", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function PrimaryButton(_ref) {
  var children = _ref.children,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().primaryButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}
function BrandButton(_ref2) {
  var children = _ref2.children,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref2, _excluded2);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().brandButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}
function SecondaryButton(_ref3) {
  var children = _ref3.children,
      _ref3$onClick = _ref3.onClick,
      onClick = _ref3$onClick === void 0 ? function () {} : _ref3$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().secondaryButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}

/***/ }),

/***/ 19148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function CustomHead(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [title, " | ", "SUPERMARKET Κρητικός"]
    }), children]
  });
}

/***/ }),

/***/ 10625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainLogo; }
/* harmony export */ });
/* harmony import */ var _MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61680);
/* harmony import */ var _MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


function MainLogo() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
    className: (_MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1___default().logo),
    width: "160",
    height: "56",
    src: "/assets/".concat("kritikos", "/logo.svg"),
    alt: "".concat("kritikos", " logo"),
    "data-cy": "logo"
  });
}

/***/ }),

/***/ 85960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DigitalCards; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3805);
/* harmony import */ var _components_CustomHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19148);
/* harmony import */ var _components_MainLogo_MainLogo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10625);
/* harmony import */ var _digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94142);
/* harmony import */ var _digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








function DigitalCards() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  function onClickLogin() {
    router.push({
      pathname: '/login',
      query: {
        isDigital: 'digital'
      }
    });
  }

  function onClicRegister() {
    router.push({
      pathname: '/register-digital-card'
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("section", {
    className: (_digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_CustomHead__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      title: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 Digital Card/ \u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE Digital Card"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: (_digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6___default().logoContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
        href: "/",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_MainLogo_MainLogo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h1", {
      className: (_digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6___default().header),
      children: "\u0391\u03C0\u03CC\u03BA\u03C4\u03B7\u03C3\u03B5 \u03C4\u03B7 \u03B4\u03B9\u03BA\u03AE \u03C3\u03BF\u03C5 \u03C8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: (_digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6___default().imageContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
        className: (_digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6___default().img),
        width: "200",
        height: "200",
        src: "/assets/".concat("kritikos", "/").concat("kritikos", "-login.png"),
        alt: "grocery app"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
      className: (_digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6___default().p),
      children: "\u0395\u03AC\u03BD \u03AD\u03C7\u03B5\u03B9\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1 \u039A\u03A1\u0397\u03A4\u0399\u039A\u039F\u03A3 \u03C4\u03CC\u03C4\u03B5 \u03B5\u03AF\u03C3\u03B1\u03B9 \u03AE\u03B4\u03B7 \u03BC\u03AD\u03BB\u03BF\u03C2 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03BF\u03C2 \u03B5\u03C0\u03B9\u03B2\u03C1\u03AC\u03B2\u03B5\u03C5\u03C3\u03B7\u03C2. \u039A\u03AC\u03BD\u03B5 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03BA\u03B1\u03B9 \u03BC\u03B5\u03C4\u03AD\u03C4\u03C1\u03B5\u03C8\u03B5 \u03C4\u03B7\u03BD \u03BA\u03AC\u03C1\u03C4\u03B1 \u03C3\u03BF\u03C5 \u03C3\u03B5 \u03C8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C4\u03B7\u03BD \u03AD\u03C7\u03B5\u03B9\u03C2 \u03C0\u03AC\u03BD\u03C4\u03B1 \u03BC\u03B1\u03B6\u03AF \u03C3\u03C4\u03BF \u03BA\u03B9\u03BD\u03B7\u03C4\u03CC \u03C3\u03BF\u03C5!"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
      className: (_digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6___default().secondParagraph),
      children: "\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03BA\u03C4\u03B9\u03BA\u03AC \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C2 \u03BD\u03B1 \u03BA\u03AC\u03BD\u03B5\u03B9\u03C2 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03AC\u03BC\u03B5\u03C3\u03B1 \u03BA\u03B1\u03B9 \u03B3\u03C1\u03AE\u03B3\u03BF\u03C1\u03B1 \u03CE\u03C3\u03C4\u03B5 \u03BD\u03B1 \u03B5\u03C0\u03C9\u03C6\u03B5\u03BB\u03B7\u03B8\u03B5\u03AF\u03C2 \u03B1\u03C0\u03CC \u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: (_digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6___default().primaryButtonContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .PrimaryButton */ .KM, {
        type: "submit",
        "data-cy": "log-in-digital",
        style: {
          width: '100%'
        },
        onClick: function onClick() {
          return onClickLogin();
        },
        children: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: (_digital_cards_module_scss__WEBPACK_IMPORTED_MODULE_6___default().secondaryButtonContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_2__/* .SecondaryButton */ .kq, {
        onClick: function onClick() {
          return onClicRegister();
        },
        "data-cy": "register-digital",
        style: {
          width: '100%',
          marginBottom: '1rem'
        },
        children: "\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE"
      })
    })]
  });
}

/***/ }),

/***/ 31432:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-cards",
      function () {
        return __webpack_require__(85960);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Buttons_button__qYN03","primaryButton":"Buttons_primaryButton__7N3x3","brandButton":"Buttons_brandButton__cCp9d","secondaryButton":"Buttons_secondaryButton__ruBI_"};

/***/ }),

/***/ 61680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"MainLogo_logo__zTYp1"};

/***/ }),

/***/ 94142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"digital-cards_container__T0TJ4","logoContainer":"digital-cards_logoContainer__YcTlU","header":"digital-cards_header__wJ0RU","imageContainer":"digital-cards_imageContainer__HTRkB","img":"digital-cards_img__WEKO5","p":"digital-cards_p__8VWzn","secondParagraph":"digital-cards_secondParagraph__JB_fg","primaryButtonContainer":"digital-cards_primaryButtonContainer__EXrTb","secondaryButtonContainer":"digital-cards_secondaryButtonContainer__R7Q9x"};

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3996,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(31432); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);